import { Box, Typography, Container, Grid, useTheme } from "@mui/material";
import { styled } from '@mui/material/styles';
import supreetImg from "./assets/supreet.jpg";

const StyledImage = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: '400px',
  borderRadius: '16px',
  boxShadow: '0 20px 40px -10px rgba(0,0,0,0.2)',
  transition: 'all 0.4s ease-in-out',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: '0 30px 60px -10px rgba(0,0,0,0.3)'
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: '350px',
    margin: '0 auto 40px'
  }
}));

function AboutUsSection() {
  const theme = useTheme();
  
  return (
    <Box 
      id="about"
      sx={{ 
        py: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: theme.palette.background.default,
          zIndex: 1,
        }
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
          {/* Text Content */}
          <Box sx={{
            width: { xs: '100%', md: 'calc(100% * 7/12 - 24px)' },
            order: { xs: 2, md: 1 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <Box sx={{
              maxWidth: '700px',
              textAlign: { xs: 'center', md: 'left' },
              width: '100%'
            }}>
              <Typography 
                variant="h2" 
                component="h2"
                sx={{ 
                  color: 'primary.main',
                  mb: 3,
                  fontWeight: 700,
                  position: 'relative',
                  display: 'inline-block',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '-10px',
                    left: { xs: '50%', md: '0' },
                    transform: { xs: 'translateX(-50%)', md: 'none' },
                    width: '80px',
                    height: '4px',
                    background: theme.palette.secondary.main,
                    borderRadius: '2px'
                  }
                }}
              >
                About Supreet
              </Typography>
              
              <Typography 
                variant="h5" 
                component="p"
                sx={{ 
                  color: 'text.secondary',
                  mb: 4,
                  fontWeight: 500,
                  lineHeight: 1.6
                }}
              >
                Certified Life & Leadership Coach | Founder of Coachivate
              </Typography>
              
              <Box sx={{ 
                '& > p': {
                  color: 'text.primary',
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: '1.1rem'
                }
              }}>
                <Typography>
                  With over a decade of corporate experience, I blend real-world insights with 
                  reflective coaching to help you grow and thrive. My approach is collaborative 
                  and supportive, focusing on unlocking your strengths and creating meaningful 
                  change in your life and career.
                </Typography>
                
                <Typography>
                  As a working professional and mother, I understand the challenges of balancing 
                  ambition with personal life. I'm dedicated to helping you navigate these 
                  challenges and step confidently into your next chapter.
                </Typography>
                
                <Typography sx={{ 
                  fontStyle: 'italic',
                  color: 'primary.main',
                  fontWeight: 500,
                  mt: 4,
                  position: 'relative',
                  pl: 3,
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '60%',
                    width: '4px',
                    background: theme.palette.secondary.main,
                    borderRadius: '2px'
                  }
                }}>
                  At Coachivate, we believe in the power of hope, growth, and meaningful change. 
                  Let's create your success story together.
                </Typography>
              </Box>
            </Box>
          </Box>
          
          {/* Image */}
          <Box sx={{ 
            width: { xs: '100%', md: 'calc(100% * 5/12 - 24px)' },
            order: { xs: 1, md: 2 },
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-end' },
            alignItems: 'center'
          }}>
            <StyledImage 
              src={supreetImg}
              alt="Supreet - Founder of Coachivate"
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default AboutUsSection;
